<!--
     <LineDatetimeChart
       title="My title"
       :chardata="chardata"
     >

     chardata = {
       horitzontal: false, // default
       entries: {
         'My line 1': [
           {y: '2024-09-10T14:52:19', x: 1, name: 'Patata'}
         ],
       },
       first_date: '2024-08-27T16:19:09' // JS isoformat
       interval: 24 * 3600 * 1000 // miliseconds
     }
-->

<template>
  <highcharts
    :options="chart_options"
    ref="chart"
    style="width: 100%; height: 100%;"
  />
</template>


<style lang="scss">
</style>


<script>
 export default {
   name: "LineDatetimeChart",

   props: {
     title: {required: true},
     subtitle: {required: false},
     chardata: {required: true},
   },

   computed: {
     chart_options() {
       const res = {
         chart: {
           type: 'line',
           zoomType: 'y',
           backgroundColor: 'transparent',
         },

         title: {
           text: '',
         },

         subtitle: {
           text: this.subtitle,
         },

         xAxis: {
           ordinal: false,
           type: 'datetime',
           title: {
             text: null,
           },
           accessibility: {
             description: this.subtitle,
           }
         },

         yAxis: {
           title: {
             text: null,
           },
           labels: {
             overflow: 'justify',
             format: '{value}'
           }
         },

         series: Object.entries(this.chardata.entries).map(([key, values]) => ({
           name: key,
           data: values.map(v => ({...v, x: Date.parse(v.x)})),
         })),

         plotOptions: {
           column: {
             dataLabels: {
               enabled: true,
               format: '{y}'
             }
           }
         },

         tooltip: {
           valueSuffix: '',
           stickOnContact: true,
           backgroundColor: 'rgba(255, 255, 255, 0.93)'
         },

         legend: {
           enabled: false
         },
         credits: {
           enabled: false
         },
       };
       return res;
     },
   },
 };
 
</script>
